import { Box, Typography, Button } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutlined";

// The "N selected → Delete Selected · Clear" bar shown above a table when one
// or more rows are checked. Shared by every list page that supports bulk
// delete. Renders nothing when the selection is empty.
export default function SelectionActionBar({
  count,
  onDelete,
  onClear,
  busy,
  colors,
}) {
  if (!count) return null;
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 2,
        mb: 2,
        px: 2.5,
        py: 1.5,
        borderRadius: 2,
        background: "rgba(239, 68, 68, 0.08)",
        border: "1px solid rgba(239, 68, 68, 0.25)",
      }}
    >
      <Typography
        sx={{ fontSize: 14, fontWeight: 600, color: colors.text, flex: 1 }}
      >
        {count} selected
      </Typography>
      <Button
        onClick={onDelete}
        startIcon={<DeleteOutlineIcon />}
        disabled={busy}
        sx={{
          textTransform: "none",
          fontWeight: 600,
          fontSize: 13,
          px: 2,
          py: 0.75,
          borderRadius: 2,
          color: "#fff",
          background: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
          boxShadow: "0 4px 14px rgba(239, 68, 68, 0.35)",
          "&:hover": { transform: "translateY(-1px)" },
          transition: "all 0.15s ease",
        }}
      >
        Delete Selected
      </Button>
      <Button
        onClick={onClear}
        sx={{
          textTransform: "none",
          fontWeight: 600,
          fontSize: 13,
          color: colors.textMuted,
          "&:hover": { background: colors.hover },
        }}
      >
        Clear
      </Button>
    </Box>
  );
}
